import { PropertyReference } from "./property-reference";

export class ActionDefinition {
    public id: string;
    public name: string;
    public description: string;
    public topic: ActionTopic;
    public priority: string;
    public iconUrl: string;
    public userTypeFiltered: boolean;
    public userTypeIds: string[];
    public writeUserTypeIds: string[];
    public event: string;
    public alertDefinitionIds: string[];
    public duePeriodTime: number;
    public duePeriodTimeUnit: string;
    public thingDefinitionId: string;
    public activationType: ActivationType;
    public period: ActivationPeriod;
    public periodCount: number;
    public dayOfMonth: number;
    public reschedulable: boolean;
    public dayOfWeek: number;
    public technicalDescription: string;
    public doneEventDefinitionId: string;
    public label: string;
    public workTime: number;
    public mandatoryDiscardReason: boolean;
    public propertyReferences: PropertyReference[];
    public sparePartReferences: ActionDefinitionSparePartReference[];
    public usageThreshold: number;
    public usageMetricId: string;
}

export enum ActionTopic {
    CONSUMABLES = "CONSUMABLES",
    PERFORMANCE = "PERFORMANCE",
    MAINTENANCE = "MAINTENANCE",
    OPERATIONS = "OPERATIONS"
}

export enum ActionPriority {
    LOW = "LOW",
    NORMAL = "NORMAL",
    HIGH = "HIGH"
}

export enum ActivationType {
    EVENT = "EVENT",
    PERIOD = "PERIOD",
    MANUAL = "MANUAL",
    USAGE = "USAGE"
}

export enum ActivationPeriod {
    DAILY = "DAILY",
    MONTHLY = "MONTHLY",
    WEEKLY = "WEEKLY"
}

export class ActionDefinitionType {
    id: string;
    value: string;
    label: string;
}

export class ActionDefinitionSparePartReference {
    code: string;
    quantity: number;
    format: string;
}